import Formsy from 'formsy-react';
import _ from 'lodash';
import React from 'react';
import {Input, Checkbox} from '../form';
import {Link} from '../'
import {register} from '../../api/'
import * as Paths from '../../constants/Paths'

class RegisterForm extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      serverError: null
    };

  }

  onValidSubmit(model) {

    const { onSuccess = _.noop, onError = _.noop, hardcodeEmail = null } = this.props;
    this.setState({isProcessing: true, serverError: null});

    register(hardcodeEmail || model.email, model.password1, model.password2, model.agreedtoterms)
      .then((res) => {
        this.setState({isProcessing: false, serverError: null});

        if (typeof FS !== "undefined")
          FS.identify(res.user.id, {
            email: res.user.email,
            gf_premium: res.user.gf_premium,
            customer_id: res.user.customer_id
          });

        onSuccess(res.user);

      })
      .catch((e) => {
        this.setState({isProcessing: false, serverError: e.message});
        onError(e.message);
      });

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, serverError } = this.state;
    const { className, hardcodeEmail = null } = this.props;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onInvalidSubmit={() => this.onInvalidSubmit() }
              className={className}>
        {hardcodeEmail ? (
          <div className="pt-form-group">
            <input type="email" className="pt-input pt-large pt-disabled" defaultValue={hardcodeEmail} />
          </div>
        ) : (
          <Input name="email"
                 type="email"
                 label="Email"
                 icon="envelope"
                 showErrors={showErrors}
                 validations="isEmail"
                 inputSize="pt-large"
                 autofocus
                 validationError="This is not a valid email"
                 required />
        )}
        <Input name="password1"
               type="password"
               label="Password"
               icon="key"
               showErrors={showErrors}
               inputSize="pt-large"
               required />
        <Input name="password2"
               label="Password Repeat"
               icon="key"
               type="password"
               showErrors={showErrors}
               inputSize="pt-large"
               required />
        <Checkbox name="agreedtoterms"
                  label={<div>I accept the <Link to={Paths.TERMS}>terms</Link> and <Link to={Paths.PRIVACY_POLICY}>privacy policy</Link>.</div>}
               icon="key"
               type="password"
               showErrors={showErrors}
               inputSize="pt-large"
               required />
        {serverError && (
          <div className="pt-callout pt-intent-danger s4">
            {serverError}
          </div>
        )}
        {!isProcessing ? (
          <button type="submit" className="pt-button pt-large pt-icon-log-in pt-intent-primary">Submit</button>
        ) : (
          <button type="submit" className="pt-button pt-disabled pt-large pt-icon-log-in">Submitting...</button>
        )}
      </Formsy>
    );
  }
}

export default RegisterForm;


// WEBPACK FOOTER //
// ./src/components/forms/RegisterForm.js